import { render, staticRenderFns } from "./NoDataOrUserNotActive.vue?vue&type=template&id=12f5e54b"
import script from "./NoDataOrUserNotActive.vue?vue&type=script&lang=js"
export * from "./NoDataOrUserNotActive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports